import { reactive } from 'vue'

const errorHandler = reactive({
  isVisible: false,
  errorCode: null,
  errorMessage: '',
  waitTime: 60 // Default wait time for 429 errors
})

/**
 * Sets an error in the global error handler.
 * @param {number|null} code - The HTTP status code (e.g., 429, 403, 500) or null for generic errors.
 * @param {string} message - The error message to display.
 * @param {number|null} waitTime - Countdown time in seconds for rate limiting (optional).
 */
function setError (code, message, waitTime = null) {
  errorHandler.isVisible = true
  errorHandler.errorCode = code
  errorHandler.errorMessage = message
  if (waitTime !== null) {
    errorHandler.waitTime = waitTime
  }
}

/**
 * Clears the current error from the global error handler.
 */
function clearError () {
  errorHandler.isVisible = false
  errorHandler.errorCode = null
  errorHandler.errorMessage = ''
  errorHandler.waitTime = 60 // Reset to default wait time
}

export { errorHandler, setError, clearError }
